import { gql } from '@apollo/client';

export const tenantInterestedOnAppliedEstateMutation = gql`
  mutation AddTenantInterestOnAppliedEstate($estateId: String!) {
    addTenantInterestOnAppliedEstate(estateId: $estateId) {
      value
    }
  }
`;

export type TenantInterestedOnAppliedEstateRequestDto = {
  estateId: string;
};

export type TenantInterestedOnAppliedEstateResponseDto = {
  addTenantInterestOnAppliedEstate: {
    value: string;
  };
};
